import TextInput from '../TextInput';
import { STATUS } from '../../constants/index';
import FilterListFilled from '../../../../assets/images/FilterListFilled.svg';
import ArrowDropDownFilled from '../../../../assets/images/arrowDropDownFilled.svg';
import styles from './index.module.scss';

interface ListFilterProps {
    filterByName: (name: string) => void;
    filterByStatus: (status: string) => void;
    filterByVolume?: (volume: string) => void;
    nameFilter: string;
    statusFilter: string;
    volumeFilter?: string;
    volumeList?: any[];
    clearFilters: () => void;
    hasAdvancedFilters?: boolean;
    onOpenFiltersModal?: () => void;
    advancedFiltersComponent?: React.ReactNode;
    showStatusFilter?: boolean;
    showNameLabel?: boolean;
    searchIcon?: string;
    // Advanced filter values
    languageFilter?: string;
    createdDateFilter?: string;
    createdByFilter?: string;
    folderCountFilter?: string;
    lastModificationDateFilter?: string;
    noFoldersFilter?: string;
}


const ListFilter = ({
    filterByName,
    filterByStatus,
    filterByVolume,
    nameFilter,
    statusFilter,
    volumeFilter,
    volumeList,
    showStatusFilter = true,
    showNameLabel = true,
    searchIcon,
    clearFilters,
    hasAdvancedFilters = false,
    onOpenFiltersModal,
    advancedFiltersComponent,
    languageFilter = "All",
    createdDateFilter = "All",
    createdByFilter = "All",
    folderCountFilter = "All",
    lastModificationDateFilter = "All",
    noFoldersFilter = "All"
}: ListFilterProps) => {
    const hasFilters = nameFilter ||
        statusFilter !== 'All' ||
        (volumeFilter && volumeFilter !== 'All') ||
        languageFilter !== 'All' ||
        createdDateFilter !== 'All' ||
        createdByFilter !== 'All' ||
        folderCountFilter !== 'All' ||
        lastModificationDateFilter !== 'All' ||
        noFoldersFilter !== 'All';

    return (
        <div className={styles.container}>
            <div className={styles.filterContainer}>
                <TextInput
                    className={`${styles.nameFilter} ${!showNameLabel ? styles.fullWidth : ''}`}
                    title="Title"
                    name="name"
                    placeholder="Search by Name"
                    value={nameFilter}
                    onChange={(e) => filterByName(e.target.value)}
                    showLabel={showNameLabel}
                    icon={searchIcon}
                />
                {filterByVolume && volumeList && (
                    <div className={styles.volumeFilter}>
                        <div className={styles.selectContainer}>
                            <label htmlFor="volume" className={styles.label}>Volume</label>
                            <select onChange={(e) => filterByVolume(e.target.value)} value={volumeFilter || 'All'}>
                                <option value="All">All</option>
                                {volumeList.map((volume) => (
                                    <option key={volume._id} value={volume._id}>{volume.title}</option>
                                ))}
                            </select>
                            <img className={styles.arrowIcon} alt="" src={ArrowDropDownFilled} />
                        </div>
                    </div>
                )}
                {filterByStatus && showStatusFilter && (
                    <div className={styles.statusFilter}>
                        <div className={styles.selectContainer}>
                            <label htmlFor="status" className={styles.label}>Status</label>
                            <select onChange={(e) => filterByStatus(e.target.value)} value={statusFilter}>
                                <option value="All">All</option>
                                {Object.values(STATUS).map((status) => (
                                    <option key={status} value={status}>{status}</option>
                                ))}
                            </select>
                            <img className={styles.arrowIcon} alt="" src={ArrowDropDownFilled} />
                        </div>
                    </div>
                )}
                {hasFilters && (
                    <div className={styles.clearFilters}>
                        <button onClick={clearFilters}>Clear Filters</button>
                    </div>
                )}
            </div>
            {hasAdvancedFilters && (
                <div className={styles.advancedFilters}>
                    <button className={styles.cta} onClick={onOpenFiltersModal}>
                        <img className={styles.filterlistfilledIcon} alt="" src={FilterListFilled} />
                        <div className={styles.filters}>Filters</div>
                    </button>
                    {advancedFiltersComponent}
                </div>
            )}
        </div>
    );
};

export default ListFilter;